"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = require("./Query");
var BaseEntityQuery_1 = require("./BaseEntityQuery");
exports.MAX_CALL_STACK_LEVEL = 50;
var BaseContentQuery = /** @class */ (function (_super) {
    __extends(BaseContentQuery, _super);
    function BaseContentQuery(queryOptions, translationHelper) {
        return _super.call(this, queryOptions, translationHelper) || this;
    }
    BaseContentQuery.prototype.getRawValueForContentElement = function (executionOptions, contentItemKey) {
        var queryOptionsType = this.queryOptions.queryOptionsType;
        var _a = this.options, key = _a.key, entityType = _a.entityType;
        if (entityType) {
            return this.processEntities(executionOptions, function (entity) {
                if (entity) {
                    var contentObject = entity[queryOptionsType];
                    if (contentObject) {
                        var contentTypeCollection = contentObject[key];
                        if (contentTypeCollection) {
                            var culture_1 = executionOptions.culture, fallbackCulture_1 = executionOptions.fallbackCulture;
                            var contentItem = contentTypeCollection.find(function (item) { return item.culture === culture_1; });
                            if (!contentItem) {
                                contentItem = contentTypeCollection.find(function (item) { return item.culture === fallbackCulture_1; });
                            }
                            return (contentItem && contentItem[contentItemKey]);
                        }
                    }
                }
            });
        }
        var keysByContentItemKey = {
            'commentary': {
                globalContextKey: 'globalCommentaries',
                contentParentKey: 'commentaryType',
                contentValuesKey: 'commentaries',
            },
            'disclaimer': {
                globalContextKey: 'globalDisclaimers',
                contentParentKey: 'disclaimerType',
                contentValuesKey: 'disclaimers',
            },
        };
        var keysForContentItemKey = keysByContentItemKey[contentItemKey];
        if (keysForContentItemKey) {
            var globalContextKey = keysForContentItemKey.globalContextKey, contentParentKey_1 = keysForContentItemKey.contentParentKey, contentValuesKey = keysForContentItemKey.contentValuesKey;
            var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
            if (context) {
                var collection = context[globalContextKey];
                if (collection && Array.isArray(collection)) {
                    var contentParent = collection.find(function (item) { return item[contentParentKey_1] === key; });
                    if (contentParent) {
                        var contentTypeCollection = contentParent[contentValuesKey];
                        if (contentTypeCollection) {
                            var culture_2 = executionOptions.culture, fallbackCulture_2 = executionOptions.fallbackCulture;
                            var contentItem = contentTypeCollection.find(function (item) { return item.culture === culture_2; });
                            if (!contentItem) {
                                contentItem = contentTypeCollection.find(function (item) { return item.culture === fallbackCulture_2; });
                            }
                            return (contentItem && contentItem[contentItemKey]);
                        }
                    }
                }
            }
        }
    };
    return BaseContentQuery;
}(BaseEntityQuery_1.BaseEntityQuery));
exports.BaseContentQuery = BaseContentQuery;
//# sourceMappingURL=BaseContentQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/BaseContentQuery.js
// module id = 206
// module chunks = 1